import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Slider,
  TextField,
} from "@material-ui/core";
import "./quickAdd.css";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { getAllLists, updateList } from "../api-interactions/lists";
import { getCookie } from "../helperFunctions/cookie";

export const QuickAdd = (props) => {
  const [loading, setLoading] = useState(false);
  const itemTitle = useRef("");
  const [points, setPoints] = useState(0);
  const [link, setLink] = useState("");
  const [lists, setLists] = useState([]);

  const getLists = async () => {
    setLoading(true);
    const res = await getAllLists(getCookie());
    setLists(res.data.data.lists);
    setLoading(false);
  };

  useEffect(() => {
    getLists();
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  const jwt = getCookie();

  const changeLinkHandler = (e) => {
    setLink(e.target.value);
  };

  const addItemHandler = (e) => {
    e.preventDefault();

    const newItem = {
      key: "item" + Math.floor(Math.random() * 10000), // This has to change, now it's just based on luck that it's a unique key.
      name: itemTitle.current.value,
      finished: false,
      pointComplete: points,
      addedBy: user.userName,
      link,
    };

    if (
      (props.list.owner === user.email || !props.list.needPermission) &&
      !props.forceNeedAccept
    ) {
      // If user is owner of list or needPermission is turned off.
      props.list.items.push(newItem);
    } else {
      // If needPermission is turned on
      props.list.needAccept.push({ ...newItem, state: "open" });
    }
    updateList(jwt, props.list._id, props.list);
    props.setQuickAdd(false);
  };

  return (
    <>
      {!loading && (
        <div id="quickAdd-container">
          <div id="quickAdd-heading">
            <h3>Quickly add items to your list</h3>
            <IoIosCloseCircleOutline
              id="edit-list-close"
              onClick={() => props.setQuickAdd(false)}
            />
          </div>
          <form id="quickAdd-form">
            <TextField
              required
              inputRef={itemTitle}
              id="itemTitle"
              label="Item Title"
              variant="outlined"
            />
            {props.list.points && (
              <>
                <p>Amount of points you can earn:</p>
                <Slider
                  onChangeCommitted={(e, val) => setPoints(val)}
                  defaultValue={0}
                  step={10}
                  marks
                  min={0}
                  max={100}
                  aria-label="Small"
                  valueLabelDisplay="auto"
                />
              </>
            )}
            <div style={{ width: "10rem" }}>
              <FormControl style={{ width: "100%", marginBottom: "1rem" }}>
                <InputLabel id="select-link-label">Link to list</InputLabel>
                <Select
                  autoWidth
                  labelId="select-link-label"
                  label="Link to list"
                  value={link}
                  onChange={changeLinkHandler}
                >
                  <MenuItem value="">None</MenuItem>
                  {lists.map((list) => {
                    return <MenuItem value={list._id}>{list.title}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </div>
            <Button
              inputRef={points}
              type="submit"
              onClick={addItemHandler}
              variant="contained"
              color="primary"
            >
              Add item
            </Button>
          </form>
        </div>
      )}
    </>
  );
};
